import { useBrcyCode } from "core/hooks/useBrcyCode";
import { useCentrixApi } from "core/hooks/useCentrixApi";
import { useLocale } from "core/hooks/useLocale";

export function useQuickLinksWidgetSettings() {
  const brcyCode = useBrcyCode();
  const locale = useLocale();
  return useCentrixApi({
    path: "/api/app/quick-link/settings",
    parameters: {
      query: {
        brcyCode,
        locale,
      },
    },
  });
}
